import React from 'react';
import './UserItem.css';
import { useHistory } from 'react-router-dom';

const UserItem = ({number, userId, fullName, mobileNumber, status, deleteUser, blockingUser}) => {
    const history = useHistory();
    return ( 
        <div className="user-item-layer">
            <span className="align-self-center user-item-layer-number">
                <span>{number}</span>
            </span>
            <span className="image-preview-user-item mt-2 my-md-0">
            </span>
            <div className="align-self-center d-flex flex-column justify-content-between align-items-start px-2 py-3">
                <small className="font-weight-bold">
                    <span >اسم و فامیل</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{fullName}</span>
                </small>
                <small className="font-weight-bold ">
                    <span >شماره موبایل</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{mobileNumber}</span>
                </small>
                <small className="font-weight-bold ">
                    <span >وضعیت</span>
                    <span className="mx-1">:</span>
                    <span className={status === 'Enable' ?'text-success' : 'text-danger'}>{status === 'Enable' ? 'فعال' : 'مسدود'}</span>
                </small>
            </div>
            <div className="d-flex justify-content-center align-items-center flex-md-column small-margin-auto">
                <button className="btn btn-success mr-1 mr-md-0  mb-md-1 user-item-btn"
                    onClick={() => history.push('/dashboard/user', {userId: userId})}
                >
                    <i className="fa fa-eye"></i>
                </button>
                <button className="btn btn-info mr-1 mr-md-0  mb-md-1 user-item-btn"
                    onClick={() => blockingUser(userId)}
                >
                    <i className="fa fa-ban"></i>
                </button>
                <button className="btn btn-danger user-item-btn"
                    onClick={deleteUser}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        </div>

     );
}
 
export default UserItem;